<template>
    <div class="main bg-g-white-transparent">
        <section id="brn-tours-public-list" class="mt-5">
            <div class="container">
                <h6 data-v-4592b1a9="" class="text-uppercase text-wide-6 text-black">Public daily tours</h6>
                <div class="row m-0">
                    <div v-for="tour in publicTours" :key="tour.id" class="col-lg-3">
                        <TourExtendedCard
                            :tour="tour"
                            :page-slug="getPageSlugByLayout('tour-single')"
                            class="mb-4"/>
                    </div>
                    <div class="col-lg-3">
                        <TourStaticBlock/>
                    </div>
                </div>
            </div>
        </section>
        <section id="brn-tours-private-list" class="mt-5">
            <div class="container">
                <h6 data-v-4592b1a9="" class="text-uppercase text-wide-6 text-black ">Private tours</h6>
                <div class="row m-0">
                    <div v-for="tour in privateTours" :key="tour.id" class="col-lg-3">
                        <TourExtendedCard
                            :tour="tour"
                            :page-slug="getPageSlugByLayout('tour-single')"
                            class="mb-4"/>
                    </div>
                </div>
            </div>
        </section>
        <section id="brn-tours" class="diagonal diagonal-top-only">
            <BorderDecoration class="top-left" style="left: -10%"/>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 intro">
                        <h2 class="title" v-html="content['tours-hero'].data.title"></h2>
                        <img :src="'storage/components/tours-hero/' + content['tours-hero'].data.image" alt="image">
                    </div>
                    <div class="col-lg-5 mt-5 pt-3">
                        <p v-html="content['tours-hero'].data.text"></p>
                        <p class="h5 py-3">
                            <i class="bi bi-envelope-fill text-secondary me-3"></i>
                            <a :href="'mailto:' + content['tours-hero'].data.email" class="text-dark text-decoration-underline">{{ content['tours-hero'].data.email }}</a>
                        </p>
                        <p class="h5 py-3">
                            <i class="bi bi-telephone-fill text-secondary me-3"></i>
                            <a :href="'tel:' + content['tours-hero'].data.phone" class="text-dark">{{ content['tours-hero'].data.phone }}</a>
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section id="brn-tours-private" class="vh-100 bg-photo" :style="'background-image: url(\'/storage/components/tours-private-tour-promo/' + content['tours-private-tour-promo'].data.background +'\');'">
            <div class="container">
                <div class="row mb-5">
                    <span v-html="content['tours-private-tour-promo'].data.title"></span>
                </div>
                <div class="buttons">
                    <a :href="content['tours-private-tour-promo'].data.buttons[0].url" class="btn btn-secondary mx-2">{{ content['tours-private-tour-promo'].data.buttons[0].content }}</a>
                    <a :href="content['tours-private-tour-promo'].data.buttons[1].url" class="btn btn-outline-white mx-2">{{ content['tours-private-tour-promo'].data.buttons[1].content }}</a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import BorderDecoration from "../components/elements/BorderDecoration";
import TourExtendedCard from "../components/cards/TourExtendedCard";
import PageLayoutContentMixin from "../../mixins/ContentMixin";
import SettingsMixin from "../../mixins/SettingsMixin";
import {mapActions, mapGetters} from "vuex";
import TourStaticBlock from "../components/TourStaticBlock.vue";
export default {
    name: "Tours",
    components: {TourStaticBlock, TourExtendedCard, BorderDecoration},
    mixins: [PageLayoutContentMixin, SettingsMixin],
    data() {
        return {
            tags: []
        }
    },
    computed: {
        ...mapGetters('app', ['tours']),
        tagsAvailable() {
            return [...new Set(Array.prototype.concat.apply([], this.tours.filter(tour => (tour.tags !== null && tour.tags.length)).map(tour => JSON.parse(tour.tags))))];
        },

        publicTours() {
            return this.tours.filter(tour => {
                return tour.type === 'public';
            });

        },
        privateTours() {
            return this.tours.filter(tour => {
                return tour.type === 'private';
            });
        }
    },
    methods: {
        ...mapActions('app', ['fetchTours']),
        tagToggle(tag) {
            return this.tags.includes(tag) ? this.tags.splice(this.tags.indexOf(tag), 1) : this.tags.push(tag);
        }
    },
    mounted() {
        this.fetchTours();


    }
}
</script>

<style scoped>

</style>
